import http from '@libs/http';
import {
  AddSymbolToWatchlist,
  RemoveSymbolFromWatchlist,
  AddWatchlistQuery,
  WatchlistItemsQuery,
  WatchlistOverviewQuery,
  WatchlistQuery,
} from '@libs/api-reference';

import { TSE_API } from './endpoints';

export type UpdateWatchlistDataModel = { id: string; title: string };

export function getWatchlist() {
  return http.get(`${TSE_API}/watchlists/user`, {
    schema: WatchlistQuery,
  });
}

export function getWatchlistOverview() {
  return http.get<WatchlistOverviewQuery>(
    `${TSE_API}/watchlists/user/overview`,
    {
      schema: WatchlistOverviewQuery,
    }
  );
}

export function getWatchlistItems(watchListId) {
  return http.get(`${TSE_API}/watchlists/{watchListId}/instruments`, {
    urlParams: { watchListId },
    schema: WatchlistItemsQuery,
  });
}

export function addSymbolToWatchlist(data: AddSymbolToWatchlist) {
  return http.post(
    `${TSE_API}/watchlists/{watchlistId}/instruments`,
    { isinCode: data.isinCode },
    {
      urlParams: { watchlistId: data.watchlistId },
    }
  );
}

export function removeSymbolFromWatchlist(
  urlParams: RemoveSymbolFromWatchlist
) {
  return http.delete(`${TSE_API}/watchlists/{watchlistId}/instruments/{isin}`, {
    urlParams,
  });
}

export function creatNewWatchlist(data: { title: string; note?: string }) {
  return http.post<AddWatchlistQuery>(`${TSE_API}/watchlists`, data, {
    schema: AddWatchlistQuery,
  });
}

export function deleteWatchlist(id: string) {
  return http.delete(`${TSE_API}/watchlists`, {
    params: { id },
  });
}

export function updateWatchlistTitle(body: UpdateWatchlistDataModel) {
  return http.put(`${TSE_API}/watchlist/title`, body);
}
